import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import ContactInfo from "./ContactInfo";
import ContactForm from "./ContactForm";

interface Branch {
  name: string;
  phone: string;
  email: string;
  address: string;
}

interface SocialMediaIcon {
  Icon: SvgIconComponent;
}

interface ContactSectionProps {
  branches: Branch[];
  socialMediaIcons: SocialMediaIcon[];
}

const ContactSection = ({
  branches,
  socialMediaIcons,
}: ContactSectionProps) => {
  return (
    <Box sx={{ bgcolor: "#1e1e1e", py: "142px" }}>
      <Container maxWidth={false} sx={{ maxWidth: "1280px" }}>
        <Stack spacing={5} alignItems="center">
          <Typography
            sx={{
              fontFamily: "Mulish",
              fontWeight: 400,
              fontSize: "48px",
              color: "white",
            }}
          >
            Get In Touch With Us
          </Typography>
          <Typography
            sx={{
              fontFamily: "Mulish",
              fontWeight: 400,
              fontSize: "16px",
              color: "white",
            }}
          >
            Create a quick inquiry in a few clicks!
          </Typography>

          <Grid container spacing={2} sx={{ mt: "125px", px: "110px" }}>
            <Grid size={4}>
              <ContactInfo
                branches={branches}
                socialMediaIcons={socialMediaIcons}
              />
            </Grid>

            <Grid size={8}>
              <ContactForm />
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
};

export default ContactSection;
